import { EntityType } from "constants/entities.enum";
import { createEntityState } from "entities/charts/factory";
import { createMergeWithDefaults } from "entities/utils";
import { EvaChartFeatures } from "types";

import { BASE_RATE_FEATURES } from "./baseRateFeatures";

const RATE_CUM_FEATURES: Partial<EvaChartFeatures> = {
  ...BASE_RATE_FEATURES,
  survivorBiasAsForecast: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true
  }),
  typewells: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true,
    active: true
  }),
  p10: createEntityState(EntityType.P10Feature, {
    show: true,
    enabled: true
  }),
  p50: createEntityState(EntityType.P50Feature, {
    show: true,
    enabled: true
  }),
  p90: createEntityState(EntityType.P90Feature, {
    show: true,
    enabled: true
  }),
  average: createEntityState(EntityType.AverageFeature, {
    show: true,
    enabled: true
  }),
  pressureChartSettings: createEntityState(EntityType.PressureChartSettingsFeature, {
    show: true,
    enabled: true
  }),
  totalFluidChartSettings: createEntityState(EntityType.TotalFluidChartSettingsFeature, {
    show: true,
    enabled: true
  })
};

export const rateCumFeatures = createMergeWithDefaults(RATE_CUM_FEATURES);
